import { ParsedUrlQuery } from 'querystring';

export function getAdded(query: ParsedUrlQuery) {
    if (query['added']) {
        return query['added'];
    }

    return '';
}
